import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
  },
})
